import React from 'react';

import type { LayoutApp } from '@typings/layout.ts';

interface SystemErrorBoundaryProps {
  app?: LayoutApp;
  children: React.ReactNode;
}

interface SystemErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
  shouldTriggerE2EError: boolean;
}

class SystemErrorBoundary extends React.Component<SystemErrorBoundaryProps, SystemErrorBoundaryState> {
  constructor(props: SystemErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      shouldTriggerE2EError: false,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    if (this.props.app?.bus) {
      this.props.app.bus.send('appInsights/log', {
        name: 'system/error',
        properties: {
          type: 'system',
          message: error?.message,
          stack: error?.stack,
          errorLocation: window?.location?.href,
          componentStack: errorInfo?.componentStack,
          timestamp: new Date().toISOString(),
        },
      });
    }
  }

  render() {
    const { children } = this.props;
    return <>{children}</>;
  }
}

export default SystemErrorBoundary;
